import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { ReactComponent as Cancel } from '../../svgs/cancel.svg';
import {ReactComponent as DownlaodBtn} from "../../images/download.svg";
import Slider from 'react-slick';
import ReactPaginate from 'react-paginate';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import axios from 'axios';

const OddNewsCard = (props) => {
    return (
        <Link key={props.indexkey} className={"col-xl-12 0" + props.CustomClass} data-aos="fade-up" data-bs-target={"#WardrobeBox-0" + props.indexkey} data-bs-toggle="modal" to="">
            <div className="textModule1">
                <img src={props.img} alt=""></img>
                <h2 className="mt-4 pt-0 pt-lg-2 mb-3 mb-lg-3">{props.title}</h2>
                <div className='mb-3 mb-lg-5' dangerouslySetInnerHTML={{__html: props.content}}></div>
            </div>
        </Link>
    );
};

const EvenNewsCard = (props) => {
    return (
        <Link key={props.indexkey} className={"col-xl-12 0" + props.CustomClass} data-aos="fade-up" data-bs-target={"#WardrobeBox-0" + props.indexkey} data-bs-toggle="modal" to="">
            <div className="textModule1">
                {/* <img src={props.img} alt=""></img> */}
                <h2 className="mt-4 pt-0 pt-lg-2 mb-3 mb-lg-3">{props.title}</h2>
                <div className='mb-3 mb-lg-5' dangerouslySetInnerHTML={{__html: props.content}}></div>
            </div>
        </Link>
    );
};

function WardrobeBox(props){
    //  get more wardrobes
    const [hits, setHits] = useState([]);
    const [pageCount, setPageCount] = useState(1);
    const [isLoaded, setisLoaded] = useState(false);
    const [currentPage, setcurrentPage] = useState(0);
    const [query, setQuery] = useState('2'); 

    const URL = `https://www.kitchendesign.ae/apis/wp-json/wp/v2/wardrobe?page=${query}`

    const handleFetch = () => {
		fetch(URL)
			.then(response => response.json())
			.then(body => {
				setHits([...body]);
                    setPageCount(body.nbPages);
                    setisLoaded(true);
			})
			.catch(error => console.error('Error', error));
	};
	const handlePageChange = (selectedObject) => {
		setcurrentPage(selectedObject.selected);
		handleFetch();
	};
    //  get more wardrobes onClick

    // Slider script
    const PopupSlider = {
        arrow: true,
        dots:false,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
            }
        ]
      };

    // Initial List
    const GetWadrobeListEven = props.GetWadrobeBoxEven.map((el, i) => 
    i % 2 === 1 &&
         <Link className="col-xl-12" data-aos="fade-up" data-bs-target={"#WardrobeBox-0" + i} data-bs-toggle="modal" key={i} to="">
            <div className="textModule1">
                <img src={el.acf.group.featured_image.url} alt=""></img>
                <h2 className="mt-4 pt-0 pt-lg-2 mb-3 mb-lg-3">{el.title.rendered}</h2>
                <div className='mb-3 mb-lg-5' dangerouslySetInnerHTML={{__html: el.acf.short_text_listing ? el.acf.short_text_listing : null}}></div>
            </div>
        </Link>
    );
    const GetWadrobeListOdd = props.GetWadrobeBoxOdd.map((el, i) => 
    i % 2 === 0 &&
        <Link className="col-xl-12" data-aos="fade-up" data-bs-target={"#WardrobeBox-0" + i} data-bs-toggle="modal" key={i} to="">
            <div className="textModule1" >
                <img src={el.acf.group.featured_image.url} alt=""></img>
                <h2 className="mt-4 pt-0 pt-lg-2 mb-3 mb-lg-3">{el.title.rendered}</h2>
                <div className='mb-3 mb-lg-5' dangerouslySetInnerHTML={{__html: el.acf.short_text_listing ? el.acf.short_text_listing : null}}></div>
            </div>
        </Link>
    );
    // Initial List

    // Fetch more wardrobe
    // const [Contact, setContact] = useState(false);
    const history = useHistory();
    const ContactPage = () => {
        history.push('/contact-us');
    };
    const [dataMoreModalLoop,setMoreModalLoop]=useState([])
    useEffect(()=>{
    axios.get('https://www.kitchendesign.ae/apis/wp-json/wp/v2/wardrobe?_embededd&per_page=100')
        .then(res=>{
          setMoreModalLoop(res.data)
        })
        .catch(err=>{
          // console.log(err);
        })
    },[])
    const ModalLoopList=dataMoreModalLoop?.map((data,id)=>{
      return <div id={"WardrobeBox-0" + id} data-aos="fade-up" className="WardrobeBoxModal modal fade" role="dialog" key={id}>
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-body p-0">
                <button type="button" className="close" data-bs-dismiss="modal"><Cancel/></button>
                    <div className="contact_form contactFormPopup textModule2">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-xl-6 col-sm-8 col-md-7 col-lg-6">
                                <h2>{data.title.rendered}</h2>
                                <div dangerouslySetInnerHTML={{__html: data.acf.short_text}}></div>
                            </div>
                            <div className="col-xl-4 col-sm-4 col-lg-4">
                                <div className="btnProps text-center">
                                    <div className="text-start text-sm-center"><Link onClick={ContactPage} data-bs-dismiss="modal" to="/contact-us" className="enquireBtn">Enquire Now</Link></div>
                                    {data.acf.group.download_catalogue === false ? 
                                    null
                                    : <div className="text-start text-sm-center"><DownlaodBtn className="underlineBtnIcon me-3"/><a href={data.acf.group.download_catalogue} className="underlineBtn mt-4 pt-3">Download Catalogue</a></div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="PopupSlider mt-2 mb-2">
                        <Slider {...PopupSlider}>
                        {data.acf.image_slider ? data.acf.image_slider.map((child, i) =>
                            <img key={i} src={child.url}></img>
                        )
                        : null}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    </div>
    })

    return(
        <div className="WardrobeBox">
            <div className="container">
                <div className="row">
                    <div className="col-6 col-xl-6">
                        <div className="row">
                            {GetWadrobeListOdd}
                            {isLoaded ? (
                                hits.map((item, index) => {
                                    index = index + 10;
                                    return (
                                        index % 2 === 0 &&
                                        <EvenNewsCard title={item.title.rendered} img={item.acf.group.featured_image.url} indexkey={index} CustomClass={index} content={item.acf.short_text_listing}/>
                                    );
                                })
                            ) : (
                                 null
                            )}
                        </div>
                    </div>
                    <div className="col-6 col-xl-6">
                        <div className="row">
                            {GetWadrobeListEven}
                            {isLoaded ? (
                                hits.map((item, index) => {
                                    // for (index ; index <100; index = index + 2)
                                    index = index + 10;
                                    return (
                                        index % 2 === 1 &&
                                        <OddNewsCard title={item.title.rendered} img={item.acf.group.featured_image.url} indexkey={index} CustomClass={index} content={item.acf.short_text_listing}/>
                                    );
                                })
                            ) : (
                                null
                            )}
                        </div>
                    </div>
                </div>
                <div className="fetch">
                        {isLoaded ? (
                            hits.map((item) => {
                                return (
                                    <div></div>
                                );
                            })
                        ) : (
                            null
                        )}
                        {isLoaded ? (
                            <>
                            {/* <ReactPaginate
                                pageCount={1}
                                pageRange={2}
                                marginPagesDisplayed={0}
                                onPageChange={handlePageChange}
                                containerClassName={'pagination mt-md-4 mt-xl-5 pt-5 pt-lg-4 pt-xl-5 mb-md-5 pb-5'}
                                previousLinkClassName={'d-none'}
                                breakClassName={'page-link'}
                                nextLinkClassName={'page-link next'}
                                pageClassName={'page-link'}
                                disabledClassName={'disabled'}
                                activeClassName={'active'}
                            /> */}
                            </>
                        ) : (
                            <>
                             <div className="text-center mt-md-4 mt-xl-5 pt-5 pt-lg-4 pt-xl-5 mb-md-5 pb-5">
                                <a className="enquireBtn ViewMoreWardrobe" onClick={handleFetch}>View More</a>
                             </div>
                            </>
                        )} 

                </div>
            </div>
            <div className="modalBoxes">{ModalLoopList}</div>
        </div>
    );
}

export default WardrobeBox;